import { useSelector } from "react-redux";

const getCachedModules = () => {
  try {
    const cached = localStorage.getItem("modules");
    const parsed = cached ? JSON.parse(cached) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Failed to parse modules from localStorage:", error);
    return [];
  }
};

const useModules = (module = "") => {
  const reduxModules = useSelector((state) => state.modules?.modules);

  if (!module) return false;

  // 1. Check Redux state first
  const targetFromRedux = Array.isArray(reduxModules)
    ? reduxModules.find(
        (item) => item?.module?.toLowerCase() === module?.toLowerCase()
      )
    : null;

  // If found in Redux and status is explicitly defined (true or false)
  if (targetFromRedux && typeof targetFromRedux.status === "boolean") {
    return targetFromRedux.status;
  }

  // 2. Fallback to localStorage if Redux is empty or module status wasn't found
  const localModules = getCachedModules();
  const targetFromLocal = localModules.find(
    (item) => item?.module?.toLowerCase() === module?.toLowerCase()
  );

  return Boolean(targetFromLocal?.status);
};

export default useModules;